export enum CanvasType {
  ACRYLIC,
  ACRYLICANDOILSTICK,
}
